<template>
  <vs-dropdown vs-trigger-click class="booking-export-dropdown">
    <vs-button
      color="dark"
      type="border"
      icon-pack="feather"
      icon="icon-download"
      class="mr-2"
      :disabled="loading"
    >
      {{ loading ? 'Exporting…' : 'Export to Excel' }}
    </vs-button>
    <vs-dropdown-menu>
      <vs-dropdown-item @click="exportScope('current')">Export current status</vs-dropdown-item>
      <vs-dropdown-item @click="exportScope('all')">Export all statuses</vs-dropdown-item>
    </vs-dropdown-menu>
  </vs-dropdown>
</template>

<script>
import { exportBookings } from '@/utils/booking/exportBookings'

export default {
  name: 'BookingExportButton',
  props: {
    module: {
      type: String,
      required: true
    },
    buildParams: {
      type: Function,
      required: true
    }
  },
  data () {
    return { loading: false }
  },
  methods: {
    async exportScope (scope) {
      if (this.loading) return
      this.loading = true
      try {
        const params = this.buildParams(scope) || {}
        await exportBookings({ module: this.module, params })
      } catch (error) {
        this.$vs.notify({
          title: 'Export',
          text: error.message || 'Failed to export bookings',
          color: 'danger'
        })
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
